import Masonry from 'masonry-layout';

import { DOM } from '../const';

const { $document } = DOM;

const masonryGrids = () => {
  const $$masonryGrids = $('.js-masonry-grid');

  $$masonryGrids.each((i, el) => {
    const grid = new Masonry(el, {
      itemSelector: '.js-masonry-grid-item'
    });
    grid.layout();

    $document.on('lazyloaded', event => {
      if ($(event.target).closest(el).length) {
        grid.layout();
      }
    });
  });
};

export default masonryGrids;
